import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

var _dec, _class, _class2, _temp;

import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@instructure/ui-elements';
import { Spinner } from '@instructure/ui-spinner';
import t from 'format-message';
import { themeable } from '@instructure/ui-themeable';
import { scoringMethodShape } from '../../../store/shapes';
import theme from '../../theme';
var styles = {
  componentId: 'IalyE',
  template: function template(theme) {
    return "\n\n.outcomes-ui__MasteryDescription--scoreMastery {\n  background-color: #F5F5F5;\n  border: solid 1px #999999;\n  border-radius: 0.25rem;\n  margin-top: 2rem;\n  padding: 1.0rem 1.0rem;\n}\n\n.outcomes-ui__MasteryDescription--scoreMasteryText {\n  margin-top: 1rem;\n}\n";
  },
  'scoreMastery': 'outcomes-ui__MasteryDescription--scoreMastery',
  'scoreMasteryText': 'outcomes-ui__MasteryDescription--scoreMasteryText'
};

var scoringText = function scoringText(scoringMethod) {
  switch (scoringMethod.algorithm) {
    case 'decaying_average':
      return t('Mastery calculated by Decaying Average. Most recent counts as ' + '{recent_percent, number, percent} of mastery weight, average of all ' + 'other results count as {remain_percent, number, percent} of weight. ' + 'If there is only one result, the single score will be returned.', {
        recent_percent: scoringMethod.algorithm_data.decaying_average_percent,
        remain_percent: 1.0 - scoringMethod.algorithm_data.decaying_average_percent
      });

    case 'n_mastery':
      return t('Mastery calculated by n Number of Times. Must achieve mastery at ' + 'least {n_times, number} times.  Scores above mastery will be ' + 'averaged to calculate final score.', {
        n_times: scoringMethod.algorithm_data.n_mastery_count
      });

    case 'highest':
      return t('Mastery calculated by Highest Score. Mastery score reflects the highest score of a graded assessment.');

    case 'latest':
      return t('Mastery calculated by Most Recent Score. Mastery score reflects the most recent graded assessment.');

    default:
      return '';
  }
};

var masteryText = function masteryText(masteryPercent, artifactTypeName) {
  return t('By aligning to this {artifact_type_name} if the student scores above' + ' {mastery_percent, number, percent} mastery will be achieved.', {
    mastery_percent: masteryPercent,
    artifact_type_name: artifactTypeName
  });
};

var Footer = (_dec = themeable(theme, styles), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, _getPrototypeOf(Footer).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: "render",
    // eslint-disable-next-line no-undef
    value: function render() {
      var _this$props = this.props,
          artifactTypeName = _this$props.artifactTypeName,
          displayMasteryPercentText = _this$props.displayMasteryPercentText,
          scoringMethod = _this$props.scoringMethod;

      if (!scoringMethod) {
        return React.createElement(Spinner, {
          renderTitle: t('Loading')
        });
      }

      return React.createElement("div", {
        className: styles.scoreMastery,
        "data-automation": "outcomeView__scoreMethodDescription"
      }, React.createElement("div", null, React.createElement(Text, {
        size: "small"
      }, scoringText(scoringMethod))), displayMasteryPercentText && artifactTypeName && React.createElement("div", {
        className: styles.scoreMasteryText
      }, React.createElement(Text, {
        size: "small"
      }, masteryText(scoringMethod.mastery_percent, artifactTypeName))));
    }
  }]);

  Footer.displayName = "Footer";
  return Footer;
}(React.Component), _class2.propTypes = {
  artifactTypeName: PropTypes.string,
  displayMasteryPercentText: PropTypes.bool.isRequired,
  scoringMethod: scoringMethodShape
}, _class2.defaultProps = {
  artifactTypeName: null,
  scoringMethod: null
}, _temp)) || _class);
export { Footer as default };